import { takeEvery, fork, put, all, call } from "redux-saga/effects"

// Language Redux States
import {
  EDIT_CHARTCOLOR,
  LIST_CHARTCOLOR,

} from "./actionTypes"
import { chartColorSuccess, chartColorError } from "./actions"


import {
  onEditChartColor,
  onListChartColor,

} from "helpers/backend_api_helper";



// edit Language
function* editLanguage({ payload: { data, id, callback } }) {
  try {
    const response = yield call(onEditChartColor, data, id);
    yield put(chartColorSuccess(response));
    callback && callback(response);

  } catch (error) {
    yield put(chartColorError(error?.response?.data?.message || "Server Error"));
  }
}

// list Language
function* listLanguage({ payload: { data, callback } }) {
  try {
    const response = yield call(onListChartColor, data);
    yield put(chartColorSuccess(response));
    callback && callback(response);

  } catch (error) {
    yield put(chartColorError(error?.response?.data?.message || "Server Error"));
  }
}




function* configLanguageSaga() {
  yield takeEvery(EDIT_CHARTCOLOR, editLanguage);
  yield takeEvery(LIST_CHARTCOLOR, listLanguage);
}

export default configLanguageSaga;

